import { useEffect, useRef } from "react";
import { desktopBridge } from "./desktop";

export function useDesktopBadge(count: number, spaceId?: string | null) {
  const badge = desktopBridge()?.badge;
  const lastCount = useRef<number | undefined>(undefined);
  const lastSpace = useRef<string | null | undefined>(undefined);
  useEffect(() => {
    return () => {
      if (badge && lastCount.current !== 0) void badge.set(0, null).catch(() => undefined);
      lastCount.current = undefined;
    };
  }, [badge]);
  useEffect(() => {
    if (!badge) return;
    const sync = () => {
      lastCount.current = count;
      lastSpace.current = spaceId;
      void badge.set(count, spaceId).catch(() => undefined);
    };
    if (lastCount.current !== count || lastSpace.current !== spaceId) sync();
    // Retry after returning from OS notification settings or a failed IPC call.
    // Повтор після повернення з налаштувань сповіщень ОС або збою міжпроцесного виклику.
    window.addEventListener("focus", sync);
    return () => window.removeEventListener("focus", sync);
  }, [badge, count, spaceId]);
}
